module.exports = __webpack_public_path__ + "static/img/12.be08efb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/12.jpg
// module id = BfMz
// module chunks = 0